"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.issuesReferencePickerPlugin = void 0;
var _react = _interopRequireWildcard(require("react"));
var _IssueProvider = require("../IssueProvider");
var _sdk = require("../../sdk");
var _alloyProvider = require("@adsk/alloy-provider");
var _alloyReactIcon = require("@adsk/alloy-react-icon");
var _FiltersPanel = require("./FiltersPanel");
var _IssueActivityCard = _interopRequireDefault(require("./IssueActivityCard"));
var _IssueEntityCellItem = require("./IssueEntityCellItem");
var _IssuesCustomDataView = _interopRequireDefault(require("./IssuesCustomDataView"));
var _IssuesEmptyState = _interopRequireDefault(require("./IssuesEmptyState"));
var _IssuesEntityBlock = require("./IssuesEntityBlock");
var _useTranslations = require("../utils/i18n/useTranslations");
var _CreateNewEntityPanel = require("./CreateNewEntityPanel");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Provider = _ref => {
  let {
    children
  } = _ref;
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  const isInIssueProviderContext = (0, _react.useContext)(_IssueProvider.IssueProviderContext);
  if (!projectId || isInIssueProviderContext) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
  }
  return /*#__PURE__*/_react.default.createElement(_IssueProvider.IssueProvider, {
    projectId: projectId
  }, children);
};
Provider.displayName = "Provider";
const issuesReferencePickerPlugin = exports.issuesReferencePickerPlugin = {
  metadata: {
    domain: "autodesk-bim360-issue",
    type: "issue"
  },
  renderIcon: p => /*#__PURE__*/_react.default.createElement(_alloyReactIcon.CheckmarkCircleIcon, p),
  toolId: _alloyProvider.TOOL_IDS.ISSUES,
  showSearchBox: true,
  is3LOSupported: true,
  PluralText: _ref2 => {
    let {
      lowerCase
    } = _ref2;
    const {
      T
    } = (0, _useTranslations.useTranslations)();
    const result = T.translate("issues");
    if (lowerCase && typeof result === "string") {
      return result.toLowerCase();
    }
    return result;
  },
  PickerModalTitle: () => {
    const {
      T
    } = (0, _useTranslations.useTranslations)();
    return T.translate("referencePickerPlugin.addReference");
  },
  AddRelationshipsButtonText: _ref3 => {
    let {
      count
    } = _ref3;
    const {
      T
    } = (0, _useTranslations.useTranslations)();
    if (count === 1) {
      return T.translate("referencePickerPlugin.addOneRelationship");
    }
    return T.translate("referencePickerPlugin.addMultipleRelationships");
  },
  SelectedCount: _ref4 => {
    let {
      count
    } = _ref4;
    const {
      T
    } = (0, _useTranslations.useTranslations)();
    return T.translate("referencePickerPlugin.issuesSelected", {
      count
    });
  },
  queryEntities: async _ref5 => {
    let {
      projectId,
      pageLimit,
      filters: {
        searchExpression,
        ...filters
      }
    } = _ref5;
    const offset = filters.offset || 0;
    const sdk = (0, _sdk.createSDK)({
      projectId
    });
    try {
      const {
        results: data,
        pagination
      } = await sdk.Issues.getAll({
        limit: pageLimit,
        offset: offset,
        filterBy: {
          title: searchExpression ? "~%".concat(searchExpression, "%") : "",
          ...filters
        },
        sortBy: {
          attribute: _sdk.IssueSortingField.DisplayId,
          direction: _sdk.IssueSortingDirection.Desc
        }
      });
      const hasNextPage = pagination.totalResults > offset + pageLimit;
      return {
        data,
        nextPageQuery: hasNextPage ? {
          projectId,
          pageLimit,
          filters: {
            ...filters,
            offset: offset + pageLimit
          }
        } : undefined
      };
    } catch {
      return {
        data: []
      };
    }
  },
  getEntitiesByIds: async _ref6 => {
    let {
      ids,
      projectId
    } = _ref6;
    const sdk = (0, _sdk.createSDK)({
      projectId
    });
    try {
      const {
        results: data
      } = await sdk.Issues.getAll({
        filterBy: {
          id: ids
        }
      });
      return {
        data
      };
    } catch {
      return {
        data: []
      };
    }
  },
  FiltersPanel: _FiltersPanel.FiltersPanel,
  EntityBlock: _IssuesEntityBlock.IssuesEntityBlock,
  canCreate: async _ref7 => {
    let {
      projectId
    } = _ref7;
    const sdk = (0, _sdk.createSDK)({
      projectId
    });
    const currentUserPermissions = await sdk.CurrentUserPermissions.get();
    return currentUserPermissions.permissionLevels.includes(_sdk.CurrentUserPermissionLevel.Create);
  },
  CreateNewEntityPanel: _CreateNewEntityPanel.CreateNewEntityPanel,
  ActivityCard: _IssueActivityCard.default,
  Provider,
  EntityMenuItem: _IssueEntityCellItem.IssueEntityCellItem,
  CustomDataView: _IssuesCustomDataView.default,
  CustomPickerEmptyState: _IssuesEmptyState.default
};
//# sourceMappingURL=issuesReferencePickerPlugin.js.map